module.exports = "/_next/static/resources/art-f9fdd884d8e2dc1ac044bcf662881fd0.webp";